(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Pop-Ups"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mokurra-seasonal-popup')) {
    customElements.define('mokurra-seasonal-popup', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.editor = this.dataset.editor === 'true';
        this.key = 'mokurra-offer:' + this.dataset.section + ':' + this.dataset.campaign;
        this.expiry = Date.parse(this.dataset.end);
        this.endValid = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(Z|[+-]\d{2}:\d{2})$/.test(this.dataset.end) && Number.isFinite(this.expiry);
        const deadline = this.querySelector('.mhp-deadline');
        if (deadline && this.endValid) {
          const date = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', day: 'numeric', month: 'long', year: 'numeric' }).format(this.expiry);
          const time = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).format(this.expiry);
          const el = deadline.querySelector('time');
          el.dateTime = this.dataset.end;
          el.textContent = date + ' · ' + time + ' UK time';
          deadline.hidden = false;
        }
        this.querySelectorAll('[data-dismiss]').forEach(button => button.addEventListener('click', () => this.dialog.close(), options));
        this.querySelector('[data-cta]').addEventListener('click', () => this.dialog.close(), options);
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const r = this.dialog.getBoundingClientRect();
          if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.dialog.close();
        }, options);
        this.dialog.addEventListener('close', () => { this.unlock(); this.remember(); }, options);
        document.addEventListener('shopify:section:select', event => {
          if (event.detail.sectionId === this.dataset.section && this.editor) this.open(true);
        }, options);
        document.addEventListener('shopify:section:deselect', event => {
          if (event.detail.sectionId === this.dataset.section && this.dialog.open) this.dialog.close();
        }, options);
        if (this.editor) {
          if (this.dataset.preview === 'true') this.timer = setTimeout(() => this.open(true), 300);
          return;
        }
        if (this.dataset.enabled !== 'true' || !this.endValid || Date.now() >= this.expiry || this.wasDismissed()) return;
        this.timer = setTimeout(() => this.open(), Number(this.dataset.delay) * 1000);
      }
      wasDismissed() {
        try {
          const until = Number(localStorage.getItem(this.key));
          return until > Date.now();
        } catch (_) { return false; }
      }
      remember() {
        if (this.editor || this.dataset.frequency === '0') return;
        try { localStorage.setItem(this.key, String(Date.now() + Number(this.dataset.frequency) * 86400000)); } catch (_) { }
      }
      open(preview = false) {
        if (!this.isConnected || this.dialog.open) return;
        if (!preview && (Date.now() >= this.expiry || this.wasDismissed())) return;
        if (!preview && this.dataset.mobile === 'true' && !matchMedia('(max-width: 749px)').matches) return;
        if (document.querySelector('dialog[open]')) return;
        this.dialog.showModal();
        this.previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        this.locked = true;
        if (!preview) this.expiryTimer = setInterval(() => {
          if (Date.now() >= this.expiry) this.dialog.close();
        }, 1000);
      }
      unlock() {
        clearInterval(this.expiryTimer);
        if (this.locked) document.documentElement.style.overflow = this.previousOverflow;
        this.locked = false;
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.abort.abort();
        if (this.dialog.open) this.dialog.close();
        this.unlock();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Size-mokurra"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('mokurra-scale')){
  customElements.define('mokurra-scale',class extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;
      this.ready=true;
      this.sizes=JSON.parse(this.querySelector('[data-scale-sizes]').textContent);
      this.copy=JSON.parse(this.querySelector('[data-scale-copy]').textContent);
      this.pills=[...this.querySelectorAll('[data-size-id]')];
      this.baseImage=this.dataset.baseImage||this.querySelector('.msc__image')?.getAttribute('src')||'';
      this.baseLabel=this.dataset.reference;
      const pressed=this.pills.find(b=>b.getAttribute('aria-pressed')==='true');
      this.active=this.sizes.find(s=>s.id===(this.dataset.initial||pressed?.dataset.sizeId))||this.sizes[0];
      if(!this.dataset.baseImage)this.baseLabel=this.active.label;
      this.pills.forEach(b=>b.addEventListener('click',()=>this.select(b.dataset.sizeId)));
      this.querySelector('[data-custom-tv]')?.addEventListener('input',()=>this.compare());
      this.buyBtn=this.querySelector('[data-buy]');
      this.buyBtn?.addEventListener('click',()=>this.addToCart());
      this.addEventListener('shopify:block:select',e=>{if(this.sizes.some(s=>s.id===e.detail.blockId))this.select(e.detail.blockId)});
      this.select(this.active.id);
    }
    select(id){
      const size=this.sizes.find(s=>s.id===id);if(!size)return;this.active=size;
      this.pills.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.sizeId===id)));
      ['width','height','depth'].forEach(k=>{const el=this.querySelector('[data-stat="'+k+'"]');if(el)el.textContent=size[k]>0?size[k]+' mm':'—'});
      const tv=Number(this.dataset.tv);
      const percent=this.querySelector('[data-stat="percentage"]');if(percent)percent.textContent=tv>0&&size.width>0?Math.round(size.width/tv*100)+'%':'—';
      const img=this.querySelector('.msc__image');
      if(img){const src=size.image||this.baseImage;if(src&&img.getAttribute('src')!==src){img.removeAttribute('srcset');img.removeAttribute('width');img.removeAttribute('height');img.src=src}}
      const caption=this.querySelector('[data-photo-caption]');if(caption)caption.textContent=this.dataset.photoPrefix+' '+(size.image?size.label:this.baseLabel);
      this.updateBuy();
      this.compare();
    }
    updateBuy(){
      const btn=this.buyBtn;if(!btn)return;
      const s=this.active,label=btn.querySelector('[data-buy-label]'),msg=this.querySelector('[data-buy-msg]');
      if(msg)msg.textContent='';
      let text;
      if(!s.variant){text=this.copy.unavailable;btn.disabled=true}
      else if(!s.available){text=this.copy.soldout.replace('{size}',s.label);btn.disabled=true}
      else{text=this.copy.buy.replace('{size}',s.label).replace('{price}',s.price||'');btn.disabled=false}
      if(label)label.textContent=text;
    }
    async addToCart(){
     const s=this.active,btn=this.buyBtn,msg=this.querySelector('[data-buy-msg]');
     if(!s||!s.variant||!s.available||btn.getAttribute('aria-busy')==='true')return;
     const label=btn.querySelector('[data-buy-label]');
     btn.setAttribute('aria-busy','true');label.textContent=this.copy.adding;
     if(msg)msg.textContent='';
     let added=false;
     try{
       const {CartLinesUpdateEvent}=await import('@shopify/events');
       const drawer=document.getElementById('cart-drawer');
       if(!drawer)throw new Error('Cart drawer missing');
       await customElements.whenDefined(drawer.localName);
       const sections=[...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(el=>el.dataset.sectionId))].slice(0,5);
       const payload={items:[{id:s.variant,quantity:1}],sections_url:window.location.pathname};
       if(sections.length)payload.sections=sections;
       const res=await fetch((this.dataset.cartAdd||'/cart/add')+'.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(payload)});
       const data=await res.json();
       if(!res.ok||data.status)throw new Error(data.description||String(res.status));
       added=true;
       const cartRes=await fetch((this.dataset.cartUrl||'/cart')+'.js',{headers:{'Accept':'application/json'},cache:'no-store'});
       if(!cartRes.ok)throw new Error('Cart refresh failed');
       const cart=await cartRes.json();
       const result={cart:CartLinesUpdateEvent.createCartFromAjaxResponse(cart),detail:{sections:data.sections,items:cart.items,source:'mokurra-scale',sourceId:this.id,itemCount:1,didError:false}};
       this.dispatchEvent(new CartLinesUpdateEvent({action:'add',context:'product',lines:[{merchandiseId:String(s.variant),quantity:1}],promise:Promise.resolve(result)}));
       drawer.open();
       if(msg)msg.textContent=this.copy.added.replace('{size}',s.label);
     }catch(e){
       if(msg)msg.textContent=added?this.copy.added.replace('{size}',s.label):this.copy.failed;
       console.error('[mokurra-scale]',e);
     }finally{
       btn.removeAttribute('aria-busy');
       const feedback=msg?.textContent;
       this.updateBuy();
       if(msg)msg.textContent=feedback||'';
     }
   }
   compare(){
      const input=this.querySelector('[data-custom-tv]'),output=this.querySelector('[data-comparison]');if(!input||!output)return;
      if(!input.value){output.textContent='';return}
      const width=Number(input.value);if(!input.validity.valid||width<=0){output.textContent=this.copy.error;return}
      output.textContent=this.copy.ratio.replace('{size}',this.active.label).replace('{percentage}',Math.round(this.active.width/width*100)).replace('{width}',width);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["menu-kavorri"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mokurra-halloween-controller')) {
 customElements.define('mokurra-halloween-controller',class extends HTMLElement {
  connectedCallback() {
   if (this.abort) return;
   this.root=this.closest('kavorri-menu');
   if (!this.root) return;
   this.abort=new AbortController();
   this.expiry=Date.parse(this.dataset.end);
   const valid=/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(Z|[+-]\d{2}:\d{2})$/.test(this.dataset.end || '') && Number.isFinite(this.expiry);
   this.enabled=this.dataset.enabled==='true' && valid;
   const refresh=()=>this.update();
   document.addEventListener('visibilitychange',refresh,{signal:this.abort.signal});
   window.addEventListener('pageshow',refresh,{signal:this.abort.signal});
   this.update();
  }
  update() {
   clearTimeout(this.timer);
   if (!this.isConnected || !this.root) return;
   const remaining=this.enabled ? Math.max(0,Math.ceil((this.expiry-Date.now())/1000)) : 0;
   const active=this.enabled && remaining>0;
   this.root.classList.toggle('kv-hw-live',active);
   this.root.classList.toggle('kv-halloween',active && this.dataset.menu==='true');
   if (active && !document.hidden) this.timer=setTimeout(()=>this.update(),1000);
  }
  disconnectedCallback() {
   clearTimeout(this.timer);
   if (this.abort) this.abort.abort();
   this.abort=null;
  }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["videoframe"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mokurra-flame-video')) {
  customElements.define('mokurra-flame-video', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.video = this.querySelector('video');
      if (!this.video) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const v = this.video;
      this.toggle = this.querySelector('[data-mfv-toggle]');
      this.media = this.querySelector('.mfv__media');
      this.userPaused = false;
      const rect = this.media.getBoundingClientRect();
      this.inView = rect.bottom > 0 && rect.top < window.innerHeight && rect.right > 0 && rect.left < window.innerWidth;
      this.pending = false;
      this.attempt = 0;
      v.muted = true;
      v.defaultMuted = true;
      v.loop = true;
      v.playsInline = true;
      v.setAttribute('muted', '');
      v.setAttribute('playsinline', '');
      v.setAttribute('webkit-playsinline', '');
      v.autoplay = !this.userPaused;
      v.removeAttribute('controls');
      this.setState(v.paused);
      v.addEventListener('playing', () => {
        if (!this.canPlay()) { this.pause(); return; }
        this.setState(false);
      }, options);
      v.addEventListener('pause', () => this.setState(true), options);
      v.addEventListener('error', () => {
        this.setState(true);
        v.controls = true;
      }, options);
      v.addEventListener('canplay', () => {
        if (this.canPlay() && v.paused) this.play();
      }, options);
      if (this.toggle) this.toggle.addEventListener('click', () => {
        if (v.paused || v.ended) {
          this.userPaused = false;
          this.inView = true;
          this.play();
        } else {
          this.userPaused = true;
          this.pause();
        }
      }, options);
      document.addEventListener('visibilitychange', () => this.sync(), options);
      window.addEventListener('pageshow', () => this.sync(), options);
      const resume = () => {
        if (this.canPlay() && v.paused) this.play();
      };
      document.addEventListener('touchend', resume, { ...options, passive: true });
      document.addEventListener('pointerup', resume, options);
      document.addEventListener('keydown', resume, options);
      v.addEventListener('loadeddata', resume, options);
      this.retryTimers = [400, 1200, 2500].map(delay => window.setTimeout(resume, delay));
      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting;
          this.sync();
        }, { threshold: 0.01 });
        this.io.observe(this.media);
      } else {
        this.inView = true;
        this.sync();
      }
      this.sync();
    }
    canPlay() {
      return this.isConnected && this.inView && !this.userPaused && !document.hidden;
    }
    sync() {
      if (this.canPlay()) this.play();
      else this.pause();
    }
    play() {
      if (!this.canPlay() || this.pending || !this.video.paused) return;
      const id = ++this.attempt;
      this.pending = true;
      const failed = error => {
        if (id !== this.attempt) return;
        this.pending = false;
        this.setState(this.video.paused);
        if (error && error.name === 'NotSupportedError') this.video.controls = true;
      };
      try {
        const result = this.video.play();
        if (result && typeof result.then === 'function') {
          result.then(() => {
            if (id !== this.attempt) return;
            this.pending = false;
            if (!this.canPlay()) this.pause();
            else this.setState(this.video.paused);
          }).catch(failed);
        } else {
          this.pending = false;
          this.setState(this.video.paused);
        }
      } catch (error) { failed(error); }
    }
    pause() {
      ++this.attempt;
      this.pending = false;
      this.video.pause();
      this.setState(true);
    }
    setState(paused) {
      this.classList.toggle('is-paused', paused);
      this.classList.toggle('is-playing', !paused);
      if (this.toggle) {
        this.toggle.setAttribute('aria-label', paused ? this.toggle.dataset.labelPlay : this.toggle.dataset.labelPause);
      }
    }
    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      if (this.retryTimers) this.retryTimers.forEach(timer => window.clearTimeout(timer));
      if (this.abort) this.abort.abort();
      if (this.video) this.pause();
      this.abort = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
